import React from 'react'
import { useTranslation } from 'react-i18next'

import { useProductReadContext } from '@app/context/ProductContext'

import { useNavigate } from '@lib/react-router-dom'

import { Body1, Heading3 } from '@ui/Typography'
import { Button } from '@ui/components/Button'

import styles from './PendingClassificationTest.module.scss'

export const PendingClassificationTest = () => {
  const { t } = useTranslation()
  const { isDefaultCFDProductType } = useProductReadContext()
  const navigate = useNavigate()
  const backToWalletsPath = isDefaultCFDProductType() ? 'wallets' : 'balances'

  return (
    <div className={styles.card}>
      <div className={styles.container}>
        <Heading3>{t('Profile.Your reclassification application is under review')}</Heading3>
        <Body1 className={styles.description}>
          {t('Profile.The process may take up to 7 working days')}
        </Body1>
        <Button.Primary
          size='lg'
          onClick={() => navigate(`/dashboard/traders-room/${backToWalletsPath}`)}
        >
          {t('Back to Wallets')}
        </Button.Primary>
      </div>
    </div>
  )
}
